import { useSelector } from 'react-redux';
import { selectAllCategories } from '../../store/categorySlice';
import {
  FIRST_LEVEL_CATEGORY_FIELD_ID,
  SECOND_LEVEL_CATEGORY_FIELD_ID,
  THIRD_LEVEL_CATEGORY_FIELD_ID,
} from '../../features/header/categories/constants';
import { mapNestedItemsByExactLevelAndSort } from '../../features/queue/grid/defaultCellRender/CategoryRender/utils';

export function useCategoryAttributes(fields = []) {
  const allCategories = useSelector(selectAllCategories());
  const fieldId = Number(fields?.[0]?.fieldId);

  if (fieldId === FIRST_LEVEL_CATEGORY_FIELD_ID) {
    return mapNestedItemsByExactLevelAndSort(allCategories, 1);
  }

  if (fieldId === SECOND_LEVEL_CATEGORY_FIELD_ID) {
    return mapNestedItemsByExactLevelAndSort(allCategories, 2);
  }

  if (fieldId === THIRD_LEVEL_CATEGORY_FIELD_ID) {
    return mapNestedItemsByExactLevelAndSort(allCategories, 3);
  }

  return [];
}
